import React from 'react'
import TopBar from './TopBar'
import SideBar from './SideBar'
import { Outlet } from 'react-router-dom'
import Grid from '@mui/material/Grid';
import Footer from './Footer';
import { useState } from 'react';
import { Drawer, Hidden } from '@mui/material';
import { useSelector } from 'react-redux';


const DashBoardLayout = () => {
  // const useSelector = useSelector()
  const [navOpen, setNavOpen] = useState(false);
  const navBarState = useSelector((state) => state.selectedDimensions.handelNavBarState)
  console.log("navBarState", navBarState);
  // const clickOpen=()=>{
  //   setNavOpen(!navOpen);
  // }
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TopBar setNavOpen={() => {
            setNavOpen(!navOpen)
            console.log("nav open>>>", navOpen)
          }} />
        </Grid>
        {
          navBarState ? ( 
            <Grid container xs={12} >
            <Grid item sm={0} md={2.5} lg={2.3} xl={2}>
  
              <Hidden mdDown>
                <SideBar isOpen={navOpen} />
              </Hidden>
  
              <Hidden mdUp>
                <Drawer
                  anchor='left'
                  open={
                    navOpen
                  }
                  // onMouseOutCapture={}
                  onClose={() => setNavOpen(!navOpen)}
                >
                  <SideBar />
                </Drawer>
              </Hidden>
  
            </Grid>
            <Grid xs={12} sm={12} md={9.5} lg={9.7} xl={10} sx={{ backgroundColor: "#F3F8FC" }}>
              <Outlet />
            </Grid>
  
          </Grid>
           
          ) :(
            <Grid container xs={12} >
            <Grid item sm={0} md={0.8} lg={0.7} xl={0.5}>
  
              <Hidden mdDown>
                <SideBar isOpen={navOpen} />
              </Hidden>
  
              <Hidden mdUp>
                <Drawer
                  anchor='left'
                  open={
                    navOpen
                  }
                  onClose={() => setNavOpen(false)}
                >
                  <SideBar />
                </Drawer>
              </Hidden>
  
            </Grid>
            <Grid xs={12} sm={12} md={11.2} lg={11.3} xl={11.5} sx={{ backgroundColor: "#F3F8FC" }}>
              <Outlet />
              {/* <Footer/> */}
            </Grid>
  
          </Grid>
        )
        }
       
      </Grid>
    </>
  );
}

export default DashBoardLayout